<template>
  <div class="invoice-view">
    <v-card flat v-if="isLoading">
      <v-card-text>
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </v-card-text>
    </v-card>
    <div v-else>
      <v-card flat>
        <ReportViewBar :title="reportName()" />

        <v-container fluid grid-list-lg>
          <v-layout row wrap class="no-print">
            <v-flex xs12 md4>
              <div>Select Department</div>
              <v-autocomplete dense autofocus hide-details :items="Classes" clearable item-text="name"
                v-model="selectedClass" return-object label="Select Department" outlined><template slot="item"
                  slot-scope="{ item }">
                  <span>{{ item.name }}</span>
                  <v-spacer></v-spacer>
                  <v-chip color="grey lighten-3">
                    <v-avatar left class="grey lighten-2">
                      <v-icon small>mdi-account-school-outline</v-icon>
                    </v-avatar>
                    <span>{{ item.studentCount }}</span>
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 md4 v-if="selectedClass">
              <div>Select Class Room</div>
              <v-autocomplete dense autofocus hide-details :items="ClassRoom" clearable item-text="name"
                v-model="selectedClassRoom" return-object label="Select Class Room" outlined><template slot="item"
                  slot-scope="{ item }">
                  <span>{{ item.name }}</span>
                  <v-spacer></v-spacer>
                  <v-chip color="grey lighten-3">
                    <v-avatar left class="grey lighten-2">
                      <v-icon small>mdi-account-school-outline</v-icon>
                    </v-avatar>
                    <span>{{ item.studentCount }}</span>
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-flex>
          </v-layout>
          <!-- <div v-if="selectedClassRoom" class="text-center">{{selectedClassRoom.name}}</div> -->
          <table class="center">
            <!-- <v-divider class="mx-3"></v-divider> -->
            <tbody class="report-container">
              <v-card-text class="pt-0">
                <!-- <v-data-table
                  dense
                  sort-by="name"
                  :headers="headers"
                  :itemsPerPage="Student.length"
                  hide-default-footer
                  :items="Student"
                >
                </v-data-table> -->
                <v-data-table v-if="Student" dense :headers="headers" :items="Student" :loading="isLoading"
                  sort-by="localId" hide-default-footer :items-per-page="Student.length">
                  <template v-slot:item="{ item }">
                    <tr class="pointer">
                      <td class="text-left">{{ item.Student.localId }}</td>
                      <td class="text-left">
                        <span class="text-capitalize">{{ item.Student.fullName }}</span>


                      </td>
                      <td class="text-left" v-if="item.Student.CustomerId">
                        <div v-if="item.Student.Customer && item.Student.Customer.fatherName">{{
                          item.Student.Customer.fatherName }}</div>
                        <div v-if="item.Student.Customer && item.Student.Customer.motherName">{{
                          item.Student.Customer.motherName }}</div>

                      </td>

                      <td class="text-left" v-else>N/A
                      </td>


                      <td class="text-left" v-if="item.Student.CustomerId">
                        <div v-if="item.Student.Customer && item.Student.Customer.fatherPhoneNumber">{{
                          item.Student.Customer.fatherPhoneNumber
                          | USPhoneNumber
                        }}</div>
                        <div v-if="item.Student.Customer && item.Student.Customer.motherPhoneNumber">{{
                          item.Student.Customer.motherPhoneNumber
                          | USPhoneNumber
                        }}</div>

                      </td>

                      <td class="text-left" v-else>N/A
                      </td>

                      <td class="text-left">
                        <div v-if="item.ClassRoom">
                          {{ item.ClassRoom.name }}


                        </div>
                        <div v-else>
                          <v-chip small color="pink" text-color="white" class="font-weight-bold" label>
                            Not Assigned To Any Room
                          </v-chip>
                        </div>
                      </td>

                    </tr>
                  </template>
                  <!-- <v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}"
                    found no
                    results.</v-alert> -->
                </v-data-table>
              </v-card-text>
            </tbody>
          </table>
        </v-container>
      </v-card>
    </div>
  </div>
</template>

<script>
import classService from "@/modules/Classes/service.js";
import ReportViewBar from "@/components/ReportViewBar";
import classRoomService from "@/modules/ClassRoom/service.js";
import studentService from "@/modules/Student/service.js";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      selectedClass: null,
      selectedClassRoom: null,
      Classes: [],
      ClassRoom: [],
      showEmailBtn: false,
      isLoading: false,
      Student: null,
      headers: [
        {
          text: "ID",
          align: "left",
          value: "fullName",
          sortable: true,
        },
        {
          text: "Student Name",
          align: "left",
          value: "fullName",
          sortable: true,
        },

        {
          text: "Father Name",
          align: "left",
          value: "zip",
          sortable: true,
        },
        {
          text: "PHONE NUMBER",
          align: "center",
          value: "phoneNumber",
          sortable: true,
        },
        {
          text: "Class Room",
          align: "center",
          value: "cellNumber",
          sortable: true,
        },
      ],
      totalQty: 0,
    };
  },
  computed: {
    ...mapGetters("global", ["currentBusiness"]),
  },
  created() {
    this.getClass()
    // await this.getClassRoom()
    // this.loadData();
    if (!this.currentBusiness) this.initUser();
  },
  watch: {
    selectedClass(val) {
      console.log('selectedClassRoom', val)
      this.getClassRoom(val)
    },
    selectedClassRoom(val) {
      console.log('selectedClassRoom', val)
      this.loadData(val)
    }
  },
  components: { ReportViewBar },
  methods: {
    ...mapActions("global", ["initUser", "initBusiness"]),
    reportName() {
      if (this.selectedClassRoom) {
        return this.selectedClassRoom.name
      } else {
        return 'Student List'
      }
    },
    getClass() {
      this.loading = true;
      (this.editDialog = false), (this.createDialog = false);
      return classService.getAll().then((response) => {
        console.log("response", response);
        this.loading = false;
        this.Classes = response.data;
        return response;
      });
    },
    getClassRoom(val) {
      console.log('class room', val)
      this.loading = true;
      this.editDialog = false
      this.createDialog = false

      let where = {
        ClassId: val.id
      }

      // if (this.ClassId) where = { ClassId: val.id }

      return classRoomService.getAll(where).then((response) => {
        console.log("response", response);
        this.loading = false;
        this.ClassRoom = response.data;
        return response;
      });
    },
    loadData(val) {
      // const id = hashids.decode(this.$route.params.id);

      // console.log('i got cal', val)
      return studentService.getStudentByClassRoomId({ ClassRoomId: val.id })
        .then((response) => {
          console.log('loadData', response)
          this.$Progress.finish();
          this.Student = response.data;
          document.title = `Report - Student List`;

          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
@media print {
  container {
    height: 100%;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden;
  }

  .no-print {
    display: none;
  }

  .detailBox {
    overflow: visible;
    height: 100%;
  }

  * {
    background: 0 0 !important;
    color: #000 !important;
    box-shadow: none !important;
    text-shadow: none !important;
  }
}

.paidImg {
  position: absolute;
  left: 40%;
  top: 10%;
}

.signature {
  margin-top: 100px;
}

.center {
  background-color: white;
  margin: auto;
  width: 100%;
}

/* @media print {
  .detailBox * {
    overflow: visible;
    height: 100%;
    page-break-before: always;
  }
}
.detailBox {
  overflow: auto;
  height: 600px;
} */</style>
